var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunchProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53055 25.856L1.41467 26.7332H25.7349L26.0101 25.856H1.53055Z",
    fill: "#78BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72696 24.1709L1.61108 25.0481H25.9313L26.2065 24.1709H1.72696Z",
    fill: "#FBB900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18285 27.5522L0.965576 28.4002L25.2858 28.3856L25.5755 27.5522H1.18285Z",
    fill: "#0769B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1405 5.74612H7.31002C6.90444 5.74612 6.57129 5.42447 6.57129 5.01511C6.57129 4.97125 6.57129 4.91277 6.58577 4.86891L7.16517 1.57938C7.22311 1.22849 7.5273 0.965332 7.88942 0.965332H26.1694C27.4006 0.965332 28.4146 1.98874 28.4001 3.23145C28.4001 3.31917 28.4001 3.40689 28.3856 3.49462L28.3711 3.74316C28.2408 4.88353 27.2848 5.74612 26.1405 5.74612Z",
    fill: "#CD2A3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8085 14.4448H5.06445L5.47003 12.1495C5.71627 10.7167 6.96198 9.66406 8.39599 9.66406H27.3133L27.2119 10.4828C26.9512 12.7489 25.0537 14.4448 22.8085 14.4448Z",
    fill: "#CD2A3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9383 22.5886L3.573 22.6617L4.35518 18.188H25.7784L24.9383 22.5886Z",
    fill: "#CD2A3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 14.4455C10.2347 14.2701 9.48143 14.7379 9.27864 15.4982L8.85858 18.1883H4.35376L5.04904 14.4455H11.0024Z",
    fill: "#CD2A3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3705 3.74362L27.2987 9.66478L19.8534 10.3519L20.0707 9.66478H21.5626C22.3738 9.66478 23.0546 9.05073 23.156 8.24663L23.3008 7.04777C23.3877 6.40449 22.9242 5.81968 22.3013 5.74658C22.2579 5.74658 22.2 5.73196 22.1565 5.73196H21.3019L21.9392 3.729L28.3705 3.74362Z",
    fill: "#CD2A3F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5808,
    cy: 22.8335,
    r: 5.94423,
    fill: "white",
    stroke: "#CD2A3F",
    strokeWidth: 0.755622
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7671 24.8115H16.5615C16.4399 24.8115 16.3441 24.7692 16.2741 24.6844C16.2004 24.596 16.1746 24.491 16.1967 24.3694L16.7715 21.1638H17.5453L17.07 23.8167C17.0589 23.8756 17.07 23.9272 17.1031 23.9714C17.14 24.0157 17.1897 24.0378 17.2524 24.0378H19.9052L19.7671 24.8115ZM23.448 24.8115H22.6743L23.028 22.8219L21.7458 24.8115H21.5026L20.9278 22.8219L20.5741 24.8115H19.8003L20.4525 21.1638H21.2262L21.8729 23.4132L23.3264 21.1638H24.1002L23.448 24.8115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchProject);
export default __webpack_public_path__ + "static/media/launchProject.5a31fdbaa9d0a0275a4600b48137a3af.svg";
export { ForwardRef as ReactComponent };